import { ConfirmAccountProvider, EConfirmAccountUiState } from '../../contexts/ConfirmAccountContext';
import PageLayout from '../../layout/PageLayout/PageLayout';
import CardLoader from '../../components/Loader/Loader';
import { ERoutes } from '../../util/constants';
import { Redirect, Switch, Route } from 'react-router';
import ConfirmAccountContext from '../../contexts/ConfirmAccountContext';
import ConfirmAccountSuccess from '../../components/ConfirmAccountSuccess/ConfirmAccountSuccess';
import ConfirmAccountForm from '../../components/ConfirmAccountForm/ConfirmAccountForm';
import GlobalContext from '../../contexts/GlobalContext';
import ConfirmAccountPickOwner from '../../components/ConfirmAccountPickOwner/ConfirmAccountPickOwner';
import { FC, useContext, useMemo } from 'react';

const ConfirmAccountRouter: FC = () => {
    return (
        <Switch>
            <Route path={ERoutes.confirmAccountPickOwner}>
                <ConfirmAccountPickOwner />
            </Route>
            <Route path={ERoutes.confirmAccountDetails}>
                <ConfirmAccountForm />
            </Route>
            <Route path={ERoutes.confirmAccountSuccess}>
                <ConfirmAccountSuccess />
            </Route>
        </Switch>
    );
};

const ConfirmAccountUi: FC = () => {
    const { coBranding } = useContext(GlobalContext);
    const { confirmAccountUiState, dataIsPrePopulated } = useContext(ConfirmAccountContext);
    const readyScreen = useMemo(() => {
        if (coBranding.isDefaultFamilyAccount && !dataIsPrePopulated) {
            return ERoutes.confirmAccountPickOwner;
        }
        return ERoutes.confirmAccountDetails;
    }, [coBranding, dataIsPrePopulated]);

    switch (confirmAccountUiState) {
        case EConfirmAccountUiState.default:
        case EConfirmAccountUiState.routerParsed:
        case EConfirmAccountUiState.queryStringParsed:
        case EConfirmAccountUiState.initialized:
            return (
                <PageLayout>
                    <CardLoader />
                </PageLayout>
            );
        case EConfirmAccountUiState.ready:
            return (
                <>
                    <Redirect to={readyScreen} />
                    <ConfirmAccountRouter />
                </>
            );
        case EConfirmAccountUiState.loading:
        case EConfirmAccountUiState.softError:
            return <ConfirmAccountRouter />;
        case EConfirmAccountUiState.success:
            return (
                <>
                    <Redirect to={ERoutes.confirmAccountSuccess} />
                    <ConfirmAccountRouter />
                </>
            );
        case EConfirmAccountUiState.fatalError:
            return <Redirect to={ERoutes.error} />;
        default:
            throw new Error('Confirm Account Ui State Set Incorrectly');
    }
};

const ConfirmAccountScreen: FC = () => {
    return (
        <ConfirmAccountProvider>
            <ConfirmAccountUi />
        </ConfirmAccountProvider>
    );
};

export default ConfirmAccountScreen;
